const func = $target => {
	var autocomplete;

	$target.on('focus', function(e) {
		geolocate();
	});

	window.loader.key('maps', function() {
		autocomplete = new google.maps.places.Autocomplete($target[0], { types: ['geocode', 'establishment'] });
		autocomplete.setFields(['address_component']);
		autocomplete.addListener('place_changed', function() {
			var place = autocomplete.getPlace();
			console.log(place);

			var address = {
				address1: '',
				address2: '',
				city: '',
				stateName: '',
				zipCode: ''
			};
			var business = false;

			for (var i = 0; i < place.address_components.length; i++) {
				var addressType = place.address_components[i].types[0];
				if (addressType == 'subpremise') {
					address.address1 = place.address_components[i].long_name;
				}
				if (addressType == 'premise') {
					business = true;
					address.address1 += ' ' + place.address_components[i].long_name;
				}

				if (addressType == 'street_number') {
					if (business) {
						address.address2 = place.address_components[i].long_name;
					} else {
						address.address1 = place.address_components[i].long_name;
					}
				}
				if (addressType == 'route') {
					if (business) {
						address.address2 += ' ' + place.address_components[i].long_name;
					} else {
						address.address1 += ' ' + place.address_components[i].long_name;
					}
				}

				if (addressType == 'locality') {
					if (!business) {
						address.address2 = place.address_components[i].long_name;
					}
				}

				if (addressType == 'postal_town') {
					address.city = place.address_components[i].long_name;
				}
				if (addressType == 'administrative_area_level_2') {
					address.stateName = place.address_components[i].long_name;
				}
				if (addressType == 'postal_code') {
					address.zipCode = place.address_components[i].long_name;
				}
				if (addressType == 'country') {
					address.country = place.address_components[i].long_name;
				}
			}

			for (var property in address) {
				$('#' + property).val(address[property]);
			}

			//country
			$('#country option').each(function(i) {
				if (this.text == address.country) {
					$('#country')[0].selectedIndex = i;
				}
			});
		});
	});

	var geolocate = function() {
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(function(position) {
				var geolocation = {
					lat: position.coords.latitude,
					lng: position.coords.longitude
				};
				var circle = new google.maps.Circle({ center: geolocation, radius: position.coords.accuracy });
				autocomplete.setBounds(circle.getBounds());
			});
		}
	};
};

export default func;
